import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { ICourseAttribute } from 'src/app/shared/models/course-attribute.model';
import { ICourseFilter } from 'src/app/shared/models/course-filter.model';
import { IOlrRegistrationSummary } from 'src/app/shared/models/olr-registration-summary.model';
import { ITerm } from 'src/app/shared/models/term.model';
import { IUnifiedCourseResponse } from 'src/app/shared/models/unified-course-response.model';
import { IBasePerson } from 'src/app/shared/people/models/person';
import { environment } from 'src/environments/environment';
import { withObjectParams } from '../functions/with-object-params.function';
import { withParams } from '../functions/with-params.function';
import { ICourseInfo } from 'src/app/shared/models/course-info.model';

@Injectable({
  providedIn: 'root'
})
export class CourseRepository {

  private readonly repoUrl: string = `${environment.apiUrl}/courses`;

  constructor(private http: HttpClient) { }

  public getCourses(params: ICourseFilter): Observable<IUnifiedCourseResponse> {
    return this.http.get<IUnifiedCourseResponse>(this.repoUrl, { params: withObjectParams(params) }).pipe(
      catchError(() => ([])) //if one request for courses fails, the app will still be continue using the others
    );
  }

  public getRegistrations(sectionId: number): Observable<Array<IBasePerson>> {
    return this.http.get<Array<IBasePerson>>(`${this.repoUrl}/${sectionId}/registrations`);
  }

  public terms(pidm?: number, allTerms?: boolean, luoaOnly?: boolean, faculty?: boolean): Observable<Array<ITerm>> {
    return this.http.get<Array<ITerm>>(`${this.repoUrl}/terms`, withParams({ pidm, allTerms, luoaOnly, faculty }));
  }

  public findOlrRegistrationSummary(pidm: number, crn: string, termCode: string): Observable<IOlrRegistrationSummary> {
    return this.http.get<IOlrRegistrationSummary>(`${this.repoUrl}/olr-registration-summary`, withParams({ pidm, crn, termCode }));
  }

  public getCourseAttributes(crn: string, termCode: string): Observable<Array<ICourseAttribute>> {
    return this.http.get<Array<ICourseAttribute>>(`${this.repoUrl}/attributes`, withParams({crn, termCode}));
  }

  public getCourseInfo(crn: string, termCode: string): Observable<ICourseInfo> {
    return this.http.get<ICourseInfo>(`${this.repoUrl}/course-info`, withParams({crn, termCode}));
  }
}
